import { Injectable } from '@angular/core'
import { environment } from 'src/environments/environment'
import StackdriverErrorReporter from 'stackdriver-errors-js'

export enum LoggingSeverity {
  INFO = 'INFO',
  WARNING = 'WARNING',
  ERROR = 'ERROR'
}

@Injectable({
  providedIn: 'root'
})
export class LoggingService {
  private errorHandler: StackdriverErrorReporter

  constructor() {
    if (environment.production && environment.firebaseConfig.apiKey) {
      const key = environment.firebaseConfig?.apiKey
      const projectId = environment.firebaseConfig?.projectId
      const serviceName = environment.service || ''

      this.errorHandler = new StackdriverErrorReporter()
      this.errorHandler.start({
        key,
        projectId,
        service: serviceName
      })
    }
  }

  public reportError(err: Error) {
    if (err) {
      console.error(err)
      if (
        environment.production &&
        environment.firebaseConfig &&
        environment.firebaseConfig.apiKey
      ) {
        this.errorHandler.report(err)
      }
    } else {
      console.log('Report error called without an error')
    }
  }

  public log(msg: string, severity: LoggingSeverity) {}
}
